import Decimal from 'decimal.js';

export const createDecimal = (value: string | number): Decimal => {
  try {
    return new Decimal(value);
  } catch (error) {
    throw new Error(`无效的数值: ${value}`);
  }
};
